let TouchEventFirstTouch = false;
let TouchEventTouching = 0;
let TouchEventPinchStart = null;
let TouchEventPinchEnd = null;

export const isMobile = () => {
  return (/android|webos|iphone|ipad|ipod|blackberry|playbook|BB10|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()));
};

export const touchToMouse = (controls, event, type: any = 'move') => {
  let touches = event.changedTouches;

  // The only event allowed during 3d mode is touchend (mouseup). Since we only allow this
  // event to be passed along we need to pretend that we pressed down first
  if (controls.orbit.status) {
    if (event.type !== "touchend") {
      return;
    }
    controls.mouse.upEnabled = true;
  }

  if (type === "move") {
    // touchstart will increment TouchEventTouching
    if (event.type === "touchstart") {
      if (TouchEventTouching === 0) {
        TouchEventFirstTouch = true;
        TouchEventTouching = TouchEventTouching + 1;
      } else {
        TouchEventFirstTouch = false;
      }
    }

    // touchend will decrement TouchEventTouching
    if (event.type === "touchend") {
      TouchEventTouching = Math.max(0, TouchEventTouching - 1);
    }
  }

  // Single touch, so create a fake mouse event instead
  if (touches.length === 1) {
    // we dont want to move after a pinch effect (it will be super glitchy)
    if (type === "move") {
      if (event.type === "touchmove") {
        if (!TouchEventFirstTouch) {
          return null;
        }
      }
    }

    let first = touches[0];
    let eventType: any = "";

    switch (event.type) {
    case "touchstart":
      eventType = "mousedown";
      break;
    case "touchmove":
      eventType = "mousemove";
      break;
    case "touchend":
      eventType = "mouseup";
      break;
    default:
      return null;
    }

    event = new MouseEvent(eventType, {
      bubbles: true,
      cancelable: true,
      view: window,
      detail: 1,
      screenX: first.screenX,
      screenY: first.screenY,
      clientX: first.clientX,
      clientY: first.clientY,
      ctrlKey: false,
      altKey: false,
      shiftKey: false,
      metaKey: false,
      button: 0
    });
    return event;
  }

  // 2 finger touch (zoom in or out)
  if (touches.length === 2) {
    if (event.type === "touchmove") {
      let dist = Math.sqrt(
        (touches[0].clientX - touches[1].clientX) * (touches[0].clientX - touches[1].clientX) +
        (touches[0].clientY - touches[1].clientY) * (touches[0].clientY - touches[1].clientY)
      );

      if (TouchEventPinchStart === null) {
        TouchEventPinchStart = dist;
      } else {
        TouchEventPinchEnd = dist;
        let pinchMove = TouchEventPinchStart - TouchEventPinchEnd;
        let sign = pinchMove / (Math.abs(pinchMove));
        event = new MouseEvent('wheel', {
          bubbles: true,
          cancelable: true,
          view: window,
          screenX: 0,
          screenY: 0,
          clientX: 0,
          clientY: 0,
          detail: sign,
          ctrlKey: false,
          altKey: false,
          shiftKey: false,
          metaKey: false,
          button: 0
        });
        event.deltaY = sign;
        TouchEventPinchStart = null;
        return event;
      }
    }
  }

  return null;
};

export const randomHexColor = () => {
  return "#000000".replace(/0/g, function() {
    return (~~(Math.random() * 16)).toString(16);
  });
};

export const closestPowerOfTwo = value => {
  if (value === 0) {
    return 0;
  }

  let power = Math.ceil(Math.log(value) / Math.log(2));
  let result =  Math.pow(2, power) - 1;
  return result;
};

export const mergeTypedArray = (first, second) => {
  let firstLength = first.length;
  let secondLength = second.length;
  let arrayConstructor = first.constructor;
  let result = new arrayConstructor(firstLength + secondLength);
  result.set(first);
  result.set(second, firstLength);
  return result;
};

export const roundDigit = (num, digits) => {
  let multiplyFactor = Math.pow(10, digits);
  return Math.round( num * multiplyFactor + Number.EPSILON ) / multiplyFactor;
};

export const executeWithoutLogging = callback => {
  const logger = console.log;
  console.log = function() {};
  let response = callback();
  console.log = logger;
  return response;
};

export const windowSafeDateISO = () => {
  const date = new Date();
  return date.toISOString()
    .slice(0, 19)
    .replace('T', ' ')
    .replace(/:/g, "-");
};

export const chunkedArray = (array, size) => {
  let tmp = [...array];
  let results = [];
  while (tmp.length) {
    results.push(tmp.splice(0, size));
  }
  return results;
};
